import React from 'react'
import Navbar from '../elements/Navbar/Navbar'
import { Flex } from 'rebass'
import { colors } from '../theme'
import Textlink from '../elements/Text/TextLink'
import {
  EmailIcon,
  NavigationIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  GooglePlusIcon,
  RssIcon,
} from 'mdi-react'

const Header = ({ siteTitle, fullDesign }) => (
  <div
    style={{
      background: 'none',
      position: fullDesign ? 'absolute' : 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: fullDesign ? '200' : '10',
    }}
  >
    <div
      style={{
        margin: '0 auto',
      }}
    >
      {fullDesign && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          flexDirection={['column', 'column', 'row', 'row']}
          bg={colors.primary}
          pb={5}
          px={5}
        >
          <Flex
            color={colors.secondary}
            width={[1, , , 1 / 4]}
            display="inline"
            alignItems="center"
            justifyContent={['center']}
            mt={3}
          >
            <EmailIcon style={{ height: '18px', width: '18px' }} />
            <Textlink>jshubham0094@gmail.com</Textlink>
          </Flex>
          <Flex
            color={colors.secondary}
            width={[1, , , 1 / 2]}
            display="inline"
            // alignItems="center"
            justifyContent="center"
            mt={3}
          >
            <NavigationIcon
              style={{
                transform: 'rotate(70deg)',
                height: '18px',
                width: '18px',
                minWidth: '18px',
              }}
            />
            <Textlink>
              1/6242-A Street No. 3 East Rohtash Nagar Shahdara Delhi 110032
            </Textlink>
          </Flex>
          <Flex
            color={colors.secondary}
            width={[1, , , 1 / 6]}
            justifyContent={['center']}
            flexDirection="row"
            display="inline"
            alignItems="center"
            mt={3}
          >
            <FacebookIcon
              style={{
                height: '18px',
                width: '18px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            />
            <TwitterIcon
              style={{
                height: '18px',
                width: '18px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            />
            <LinkedinIcon
              style={{
                height: '18px',
                width: '18px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            />
            <GooglePlusIcon
              style={{
                height: '21px',
                width: '20px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            />
            <RssIcon
              style={{
                height: '18px',
                width: '18px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
            />
          </Flex>
        </Flex>
      )}
      <Navbar fullDesign={fullDesign} />
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js